import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  frequencyCapCheckbox: {
    marginLeft: [0, '!important'],
    marginBottom: 15
  }
})

export default useStyles
